import { Helmet } from 'react-helmet-async'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { clsx } from 'clsx'

import PublicDomainList from './components/PublicDomainList'
import UniversityDomainList from './components/UniversityDomainList'

import styles from './DomainManagementPage.module.scss'
import baseStyles from '@/pages/base.module.scss'

import Tabs from '@/components/Tabs'
import BlockedDomainsTab from '@/pages/app/BlockedDomains'
import { selectIsInternalAdmin } from '@/store/features/user/userSlice'

const TABS = [
  {
    label: 'Blocked B2B Domains',
    slug: 'blocked',
    Component: BlockedDomainsTab,
  },
  { label: 'Public Domain List', slug: 'public', Component: PublicDomainList },
  {
    label: 'University Domain List',
    slug: 'university',
    Component: UniversityDomainList,
  },
] as const

const DomainManagementPage = () => {
  const isInternalAdmin = useSelector(selectIsInternalAdmin)
  const navigate = useNavigate()
  const location = useLocation()

  const activeTab = Math.max(
    0,
    TABS.findIndex((tab) => location.pathname.endsWith(`/${tab.slug}`))
  )
  const { Component: ActiveTabComponent } = TABS[activeTab] ?? TABS[0]

  const handleTabChange = (index: number) => {
    navigate(`/app/domain-management/${(TABS[index] ?? TABS[0]).slug}`)
  }

  if (!isInternalAdmin) {
    return (
      <div className={styles.container}>
        <p>You are not authorized to access this page</p>
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>Wispr Flow | Domain Management</title>
      </Helmet>
      <div className={clsx(baseStyles.container, styles.container)}>
        <div className={clsx(baseStyles.tabTitle, baseStyles.pageTabTitle)}>
          <h6>Domain Management</h6>
          <Tabs tabs={TABS.map((tab) => tab.label)} activeTab={activeTab} setActiveTab={handleTabChange} />
        </div>
        <ActiveTabComponent />
      </div>
    </>
  )
}

export default DomainManagementPage
